// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared inset surface / card primitive */

.surface {
  background-color: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
  box-sizing: border-box;
  width: 100%;
}

.surface--page {
  border-radius: var(--radius-xl);
  border-color: var(--color-border-subtle);
}

.surface--section {
  border-radius: var(--radius-md);
}

.surface--nested {
  border-radius: var(--radius-sm);
  background-color: var(--color-surface-muted);
  border-color: transparent;
}

.surface--muted {
  background-color: var(--color-surface-muted);
  border-color: transparent;
}

.surface--flush {
  border: none;
  background-color: transparent;
  border-radius: 0;
}

.surface--padding-none {
  padding: 0;
}

.surface--padding-sm {
  padding: var(--space-4);
}

.surface--padding-md {
  padding: var(--space-6);
}

.surface--padding-lg {
  padding: var(--layout-page-pad);
}

@media (max-width: 768px) {
  .surface--page {
    border-radius: var(--radius-lg);
  }

  .surface--padding-lg {
    padding: var(--layout-page-pad-mobile);
  }

  .surface--padding-md {
    padding: var(--space-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Surface/Surface.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Shared inset surface / card primitive */\n\n.surface {\n  background-color: var(--color-surface);\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-lg);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.surface--page {\n  border-radius: var(--radius-xl);\n  border-color: var(--color-border-subtle);\n}\n\n.surface--section {\n  border-radius: var(--radius-md);\n}\n\n.surface--nested {\n  border-radius: var(--radius-sm);\n  background-color: var(--color-surface-muted);\n  border-color: transparent;\n}\n\n.surface--muted {\n  background-color: var(--color-surface-muted);\n  border-color: transparent;\n}\n\n.surface--flush {\n  border: none;\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.surface--padding-none {\n  padding: 0;\n}\n\n.surface--padding-sm {\n  padding: var(--space-4);\n}\n\n.surface--padding-md {\n  padding: var(--space-6);\n}\n\n.surface--padding-lg {\n  padding: var(--layout-page-pad);\n}\n\n@media (max-width: 768px) {\n  .surface--page {\n    border-radius: var(--radius-lg);\n  }\n\n  .surface--padding-lg {\n    padding: var(--layout-page-pad-mobile);\n  }\n\n  .surface--padding-md {\n    padding: var(--space-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
